// $(document).ready(function() {
//     // Convert data-src to src for all images in popup
//     $('.mySwiper-popup .swiper-slide img').each(function() {
//         var dataSrc = $(this).attr('data-src');
//         if (dataSrc) {
//             $(this).attr('src', dataSrc);
//         }
//     });

// });

window.addEventListener("load", function () {
    // Kiểm tra device type
    const isMobile = $('body').data('device-type') === 'mobile';
    
    if (isMobile) {
        // Trên mobile: sử dụng Fancybox thay vì Swiper
        initFancyboxForMobile();
    } else {
        // Trên desktop: sử dụng Swiper như cũ
        initSwiperForDesktop();
    }
});

function initFancyboxForMobile() {
    // Tạo gallery cho Fancybox từ các hình ảnh trong swiper
    const swiperSlides = document.querySelectorAll('.mySwiper-popup .swiper-slide img');
    const galleryItems = [];
    
    swiperSlides.forEach((img, index) => {
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
            galleryItems.push({
                src: dataSrc,
                type: 'image'
            });
        }
    });
    
    // Thêm click event cho từng hình ảnh
    swiperSlides.forEach((img, index) => {
        img.style.cursor = 'pointer';
        img.addEventListener('click', function() {
            showImage(index);
        });
    });
    
    // Hiển thị navigation buttons
    const swiperNav = document.querySelectorAll('.swiper-popup-next, .swiper-popup-prev');
    swiperNav.forEach(el => {
        if (el) el.style.display = 'flex';
    });
    
    // Thêm click event cho navigation buttons
    const nextBtn = document.querySelector('.swiper-popup-next');
    const prevBtn = document.querySelector('.swiper-popup-prev');
    
    let currentIndex = 0;
    
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            currentIndex = (currentIndex + 1) % 8;
            showImage(currentIndex);
        });
    }
    
    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            currentIndex = (currentIndex - 1 + 8) % 8;
            showImage(currentIndex);
        });
    }
    
    // Hàm hiển thị hình ảnh
    function showImage(index) {
        // Ẩn tất cả slides
        document.querySelectorAll('.mySwiper-popup .swiper-slide').forEach(slide => {
            slide.style.display = 'none';
        });
        
        // Hiển thị slide được chọn
        const targetSlide = document.querySelectorAll('.mySwiper-popup .swiper-slide')[index];
        if (targetSlide) {
            targetSlide.style.display = 'flex';
        }
    }
    
    // Khởi tạo hiển thị hình đầu tiên
    showImage(0);
}

function initSwiperForDesktop() {
    // Khởi tạo Swiper như cũ cho desktop
    new Swiper(".mySwiper-popup", {
        navigation: {
            nextEl: ".swiper-popup-next",
            prevEl: ".swiper-popup-prev",
        },
        pagination: {
            el: ".swiper-popup-pagination",
        }
    });
}
